<template>
  <b-modal
    id="modal-setting"
    centered
    modal-class="mc-modal-right"
    title="Atur Tampilan"
    hide-header-close
  >
    <div class="mc-control-tower__modal">
      <span class="d-block mb-1 text-muted">{{ $t('global.object.remarks') }}</span>
      <b-alert show variant="primary"
        ><p>
          {{ $t('tower.youCanSet') }}
        </p>
        <p><i class="mc-fa icon-fill_checkmark-square"></i> {{ $t('tower.clickShow') }}</p></b-alert
      >
      <div class="d-flex justify-content-between mb-1">
        <span class="text-muted">{{ $t('tower.showSensors') }}</span
        ><span class="text-muted">1/14</span>
      </div>

      <div class="mc-report__filter-draggable-wrapper">
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('global.object.fuel') }} (%)
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('global.object.fuel') }} (L)
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('global.object.mileage') }}
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('global.object.speed') }}
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('global.alert.machine') }}
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('master.list.tracker.refrigerator') }}
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('global.alert.door1') }}
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('global.alert.door2') }}
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >PTO
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >Status
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('liveView.infoWindow.temp1') }}
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('liveView.infoWindow.temp2') }}
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('liveView.infoWindow.temp3') }}
          </b-form-checkbox>
        </span>
        <span class="mc-report__filter-draggable">
          <b-form-checkbox value="accepted" unchecked-value="not_accepted" class="form-check"
            >{{ $t('global.object.tripTime') }}
          </b-form-checkbox>
        </span>
      </div>
    </div>
    <template #modal-footer>
      <div class="mc-modal__filter-footer">
        <div class="d-flex justify-content-between">
          <div>
            <b-button variant="outline-primary">{{ $t('global.resetAsset') }}</b-button>
          </div>
          <div>
            <b-button variant="outline-primary" class="me-2" @click="cancelModal()">{{
              $t('global.cancel')
            }}</b-button>
            <b-button variant="primary">{{ $t('global.action.apply') }}</b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
export default {
  methods: {
    cancelModal() {
      this.$bvModal.hide('modal-setting')
    },
  },
}
</script>
